import { useContext } from 'react';
import type { Context } from 'react';

export const useRequiredContext = <TValue>(
  context: Context<TValue | undefined>,
  missingMessage: string,
): TValue => {
  const value = useContext(context);

  if (value === undefined) {
    throw new Error(missingMessage);
  }

  return value;
};
